import TestResponse from '../../responses/test.json';
import CDAccuracyDateResponse from '../../responses/cd-accuracy-date.json';
import RewardsCounterResponse from '../../responses/rewards-counter.json';
import CardActivationResponse from '../../responses/card-activation.json';
import BankAccountValidationResponse from '../../responses/BankAccountValidation.json';
import InitCompareApiResponse from '../../responses/init-compare-api.json';
import InitAcquisitionsAdobeModeApiResponse from '../../responses/init-acquisitions-adobe-mode-api.json';
import InitCorporateAdobeModeApiResponse from '../../responses/init-corporate-adobe-mode-api.json';
import MissingInformationResponse from '../../responses/missing-info.json';
import ApplicationStatusResponse from '../../responses/application-status.json';
import SaveAgreement from '../../responses/save-agreement.json';
import DebitFundingUrl from '../../responses/debit-funding-url.json';
import PreApprovedLookupResponse from '../../responses/pre-approved-lookup.json';
import ValidateStateAndZipResponse from '../../responses/validate-state-and-zip-response.json';
import PqFullAppResponse from '../../responses/pqFullApp.json';
import SkipPqFullAppResponse from '../../responses/skipPqFullApp.json';
import PaFullAppResponse from '../../responses/paFullApp.json';
import DataExposureResponse from '../../responses/data-exposure.json';
import AppApprovedResponse from '../../responses/appApproved.json';
import AppPendingResponse from '../../responses/appPending.json';
import AuthenticateAciResponse from '../../responses/authenticate-aci.json';
import PreQualSumbitV2Response from '../../responses/pre-qual-submit-v2.json';
import SubmitApplicationUpdate from '../../responses/submit-application-update.json';
import OtpVerification from '../../responses/otp-verification.json';
import bypassVerification from '../../responses/bypass-verifciation.json';
import RefreshCurrentApplication from '../../responses/resfreshApplication.json';
import SendSMSCustomerVerificationLinkResponse from '../../responses/sendSMSLink.json';
import GetQuestionsResponse from '../../responses/getQuestions.json';
import SubmitQuestionsResponse from '../../responses/submitQuestions.json';
import GetApplicationAuthorized from '../../responses/getApplicationAuthorized.json';
import GetApplicationInfo from '../../responses/skipPQApplicationInfo.json';
import ApplicationAuthorized from '../../responses/application-authorized.json';
import InitializeAcquisitionApiResponse from '../../responses/initialize-acquisition-api.json';
import VerifyIdentificationDocumentResponse from '../../responses/verify-identification-document.json';
import RetrieveIdentificationDocumentStatusResponse from '../../responses/retrieve-identification-document-status.json';
import InstantIssuanceOffer from '../../responses/instant-issuance-offer.json';
import ApplicationDecline from '../../responses/application-decline.json';

export type APIEndpoint = {
    mock: object;
    endpoint: string;
    method?: 'GET' | 'get' | 'POST' | 'post';
};

/**
 * Map of endpoint URL's for production and mock files for dev testing
 *
 * Types for Requests: ui.frontend/src/types/requests/*.ts
 *
 * Types for Responses: ui.frontend/src/types/responses/*.ts
 *
 * For more information see: {@link https://creditone.atlassian.net/wiki/spaces/WE/pages/1648951309/Using+Dynamic+API+Util}
 */
export const API_MAPPING: { [key: string]: APIEndpoint } = {
    test: {
        endpoint: 'https://api.creditonebank.com/test',
        mock: TestResponse,
    },

    'rewards-counter': {
        endpoint: '/api/v1/rewards-counter/',
        mock: RewardsCounterResponse,
    },

    'online-activation': {
        endpoint: '/api/v1/card/unauth-activate',
        mock: CardActivationResponse,
    },

    'cd-accuracy-date': {
        endpoint:
            '/api/v1/FinxactProductRates/GetCertificateDepositProductRates',
        mock: CDAccuracyDateResponse,
    },

    'missing-information': {
        endpoint: '/api/v1/application-status/submit-missing-info',
        mock: MissingInformationResponse,
    },

    'init-compare-api': {
        endpoint: '/acquisitionapi/api/init',
        mock: InitCompareApiResponse,
    },

    'init-acquisitions-adobe-mode-api': {
        endpoint: '/acquisitionapi/api/initadobe',
        mock: InitAcquisitionsAdobeModeApiResponse,
    },

    'init-corporate-adobe-mode-api': {
        endpoint: '/api/v1/init/init-adobe',
        mock: InitCorporateAdobeModeApiResponse,
    },

    'application-status': {
        endpoint: '/api/v1/application-status/applications',
        mock: ApplicationStatusResponse,
    },

    'save-agreement': {
        endpoint:
            '/api/v2/secured-application-bank-account-verification/save-agreement',
        mock: SaveAgreement,
    },

    'bank-acct-validation': {
        endpoint:
            '/api/v2/secured-application-bank-account-verification/validate-microdeposit-application',
        mock: BankAccountValidationResponse,
    },

    'debit-funding-url': {
        endpoint: '/acquisitionapi/api/Prequal/v2/Application/GetDebitFundingURL',
        mock: DebitFundingUrl,
    },

    'pre-approved-lookup': {
        endpoint: '/acquisitionapi/api/PreApproved/v2/Solicitation/SubmitLookup',
        mock: PreApprovedLookupResponse,
    },

    'validate-state-and-zip': {
        endpoint: '/acquisitionapi/api/Shared/v1/Authorization/ValidateStateZip',
        mock: ValidateStateAndZipResponse,
    },

    'pre-qualification-submit-v2': {
        endpoint: '/acquisitionapi/api/prequal/v2/prequalification/submit',
        mock: PreQualSumbitV2Response,
    },

    'pq-full-submit': {
        endpoint: '/acquisitionapi/api/Prequal/v2/Application/Submit',
        mock: PqFullAppResponse,
    },

    'skip-pq-full-submit': {
        endpoint: '/acquisitionapi/api/SkipPrequal/v2/Submit',
        mock: SkipPqFullAppResponse,
    },

    'pa-full-submit': {
        endpoint: '/acquisitionapi/api/PreApproved/v2/Application/Submit',
        mock: PaFullAppResponse,
    },

    'pq-data-exposure': {
        endpoint:
            '/acquisitionapi/api/Prequal/v1/Prequalification/DataExposure',
        mock: DataExposureResponse,
    },

    'pa-data-exposure': {
        endpoint: '/acquisitionapi/api/PreApproved/v1/Application/DataExposure',
        mock: DataExposureResponse,
    },

    'skip-pq-data-exposure': {
        endpoint: '/acquisitionapi/api/SkipPrequal/v1/DataExposure',
        mock: DataExposureResponse,
    },

    'pq-app-approved': {
        endpoint:
            '/acquisitionapi/api/Prequal/v2/Application/ApplicationApproved',
        mock: AppApprovedResponse,
        method: 'GET',
    },

    'skip-pq-app-approved': {
        endpoint:
            '/acquisitionapi/api/SkipPrequal/v2/ApplicationApproved',
        mock: AppApprovedResponse,
        method: 'GET',
    },

    'pa-app-approved': {
        endpoint:
            '/acquisitionapi/api/PreApproved/v2/Application/ApplicationApproved',
        mock: AppApprovedResponse,
        method: 'GET',
    },

    'pq-app-pending': {
        endpoint:
            '/acquisitionapi/api/Prequal/v2/Application/ApplicationPending',
        mock: AppPendingResponse,
        method: 'GET',
    },

    'skip-pq-app-pending': {
        endpoint:
            '/acquisitionapi/api/SkipPrequal/v2/ApplicationPending',
        mock: AppPendingResponse,
        method: 'GET',
    },

    'pa-app-pending': {
        endpoint:
            '/acquisitionapi/api/PreApproved/v2/Application/ApplicationPending',
        mock: AppPendingResponse,
        method: 'GET',
    },

    'authenticate-aci': {
        endpoint: '/acquisitionapi/api/Shared/v2/Authorization/aci',
        mock: AuthenticateAciResponse,
    },

    'application-authorized': {
        endpoint: '/acquisitionapi/api/Shared/v1/Authorization/GetApplicationAuthorized',
        mock: ApplicationAuthorized,
    },

    'submit-application-update-pq': {
        endpoint:
            '/acquisitionapi/api/Prequal/v1/Application/SubmitApplicationUpdate',
        mock: SubmitApplicationUpdate,
    },

    'otp-verification': {
        endpoint: '/acquisitionapi/api/shared/v1/authorization/validateonetimepasscode',
        method: 'POST',
        mock: OtpVerification,
    },

    'bypass-verification': {
        endpoint: '/acquisitionapi/api/Shared/v1/Authorization/ResendOrBypassOneTimePasscode',
        method: 'POST',
        mock: bypassVerification,
    },

    'submit-application-update-skip-pq': {
        endpoint: '/acquisitionapi/api/skipprequal/v1/Update',
        mock: SubmitApplicationUpdate,
    },

    'submit-application-update-pa': {
        endpoint:
            '/acquisitionapi/api/preapproved/v1/application/submitapplicationupdate',
        mock: SubmitApplicationUpdate,
    },
    'send-accepted-programCode': { // TODO: update with actual mock response
        endpoint: '/acquisitionapi/api/Prequal/v1/Application/AcceptedProgramCode',
        mock: { status: 200, data: {} },
    },
    'get-questions': {
        endpoint: '/acquisitionapi/api/Shared/v2/Authorization/GetLevel3Questions',
        mock: GetQuestionsResponse,
        method: 'POST',
    },

    'submit-questions': {
        endpoint: '/acquisitionapi/api/Shared/v1/Authorization/SubmitLevel3Questions',
        mock: SubmitQuestionsResponse,
        method: 'POST',
    },

    'get-application-authorized': {
        endpoint: '/acquisitionapi/api/Shared/v1/Authorization/GetApplicationAuthorized',
        mock: GetApplicationAuthorized,
        method: 'GET',
    },

    'get-esign-rules': {
        endpoint: '/acquisitionapi/api/Shared/v1/OperationApplication/EsignRules',
        mock: { status: 200, data: { ESignRule: 'Required' } },
    },

    'skip-pq-get-application-info': {
        endpoint: '/acquisitionapi/api/SkipPrequal/v1/ApplicationInfo',
        mock: GetApplicationInfo,
    },

    'init-acquisition-api': {
        endpoint: '/acquisitionapi/api/init',
        mock: InitializeAcquisitionApiResponse,
        method: 'GET',
    },

    'retrieve-identification-document-status': {
        endpoint: '/acquisitionapi/api/Shared/v1/Authorization/RetrieveIdentificationDocumentStatus',
        mock: RetrieveIdentificationDocumentStatusResponse,
        method: 'POST',
    },

    'verify-identification-document': {
        endpoint: '/acquisitionapi/api/Shared/v1/Authorization/VerifyIdentificationDocument',
        mock: VerifyIdentificationDocumentResponse,
        method: 'POST',
    },

    'refresh-current-application': {
        endpoint: '/acquisitionapi/api/Shared/v1/Authorization/RefreshCurrentApplication',
        mock: RefreshCurrentApplication,
        method: 'POST',
    },

    'account-verification': {
        endpoint: '/acquisitionapi/api/Prequal/v2/Application/MicrodepositAgree',
        mock: {
            status: 200,
            data: true,
        },
    },

    'set-instant-issuance-offer': {
        endpoint: '/acquisitionapi/api/Shared/v1/OperationApplication/SetInstantIssuanceOffer',
        method: 'POST',
        mock: InstantIssuanceOffer,
    },

    'prequal-declined': {
        endpoint: '/acquisitionapi/api/Prequal/v2/Prequalification/PrequalDeclined',
        mock: ApplicationDecline,
    },

    'prequal-appdeclined': {
        endpoint: '/acquisitionapi/api/Prequal/v2/Application/ApplicationDeclined',
        mock: ApplicationDecline,
    },

    'skipprequal-appdeclined': {
        endpoint: '/acquisitionapi/api/SkipPrequal/v2/ApplicationDeclined',
        mock: ApplicationDecline,
    },

    'preapproved-appdeclined': {
        endpoint: '/acquisitionapi/api/PreApproved/v2/Application/ApplicationDeclined',
        mock: ApplicationDecline,
    },

    'send-sms-customer-verification-link': {
        endpoint: '/acquisitionapi/api/Shared/v1/OperationApplication/SendSMSCustomerVerificationLink',
        mock: SendSMSCustomerVerificationLinkResponse,
        method: 'POST',
    },

    'pa-validate-ssn': {
        endpoint: '/acquisitionapi/api/PreApproved/v1/Solicitation/ValidateSsn',
        mock: {
            status: 200,
            data: {
                ValidationError: null,
                ValidationSuccessful: true,
                Result: 3,
            },
        },
        method: 'POST',
    },
} as const;
